import { HomeContentState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const defaultState: HomeContentState = {
  collections: null,
  ready: false,
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'SET_HOME_CONTENT':
      return { ...state, ...action.payload }
    case 'UPDATE_HOME_CONTENT_COLLECTION': {
      const collectionToUpdate = action.payload.collection
      return {
        ...state,
        collections: state.collections?.map((collection) => {
          if (collectionToUpdate.slug === collection.slug) {
            return {
              ...collection,
              ['collection_type']: collectionToUpdate['collection_type'],
              title:
                collection.slug === 'favorite-shows'
                  ? 'My List - Shows'
                  : collection.title,
              url: collectionToUpdate.url,
              content: collectionToUpdate.content,
              meta: action.payload.meta,
            }
          }
          return collection
        }),
      }
    }
    case 'DELETE_HOME_FAVORITE':
      return {
        ...state,
        collections: state.collections?.map((collection) => {
          if (collection.slug === 'favorite-shows') {
            return {
              ...collection,
              content: collection.content?.filter(
                (c: any) => c.cid !== action.payload.cid
              ),
            }
          }
          return collection
        }),
      }
    case 'ADD_HOME_FAVORITE':
      return {
        ...state,
        collections: state.collections?.map((collection) => {
          if (collection.slug === 'favorite-shows') {
            const content = Array.isArray(collection.content)
              ? collection.content
              : []
            return {
              ...collection,
              content: [action.payload.favorite, ...content],
            }
          }
          return collection
        }),
      }
    case 'ADD_SCHEDULES_TO_HOME': {
      return {
        ...state,
        collections: [
          ...(state?.collections?.slice(0, 2) ?? []),
          {
            slug: 'livestream_now',
            title: 'Livestream Now',
            item_type: 'schedule',
            content: action.payload.channels,
          },
          ...(state?.collections?.slice(2, state.collections.length) ?? []),
        ],
      }
    }
    default:
      return state
  }
}
